var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3883_1360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 4C13.5215 4 14.3985 4.022 15.2485 4.058L16.2525 4.106L17.2135 4.163L18.1135 4.224L18.9355 4.288C19.8277 4.35589 20.6673 4.73643 21.3065 5.3626C21.9456 5.98877 22.3433 6.8204 22.4295 7.711L22.4695 8.136L22.5445 9.046C22.6145 9.989 22.6665 11.017 22.6665 12C22.6665 12.983 22.6145 14.011 22.5445 14.954L22.4695 15.864L22.4295 16.289C22.3433 17.1798 21.9454 18.0115 21.3061 18.6377C20.6667 19.2639 19.8269 19.6443 18.9345 19.712L18.1145 19.775L17.2145 19.837L16.2525 19.894L15.2485 19.942C14.3883 19.9793 13.5275 19.9986 12.6665 20C11.8055 19.9986 10.9447 19.9793 10.0845 19.942L9.0805 19.894L8.1195 19.837L7.2195 19.775L6.3975 19.712C5.50532 19.6441 4.6657 19.2636 4.02655 18.6374C3.38739 18.0112 2.98969 17.1796 2.9035 16.289L2.8635 15.864L2.7885 14.954C2.71234 13.9711 2.67164 12.9858 2.6665 12C2.6665 11.017 2.7185 9.989 2.7885 9.046L2.8635 8.136L2.9035 7.711C2.98966 6.82055 3.38722 5.98905 4.02617 5.36291C4.66512 4.73676 5.5045 4.35612 6.3965 4.288L7.2175 4.224L8.1175 4.163L9.0795 4.106L10.0835 4.058C10.944 4.02073 11.8052 4.00139 12.6665 4ZM10.6665 9.575V14.425C10.6665 14.887 11.1665 15.175 11.5665 14.945L15.7665 12.52C15.8579 12.4674 15.9338 12.3916 15.9866 12.3003C16.0394 12.209 16.0672 12.1055 16.0672 12C16.0672 11.8945 16.0394 11.791 15.9866 11.6997C15.9338 11.6084 15.8579 11.5326 15.7665 11.48L11.5665 9.056C11.4753 9.00332 11.3718 8.9756 11.2664 8.97562C11.1611 8.97563 11.0576 9.00339 10.9663 9.0561C10.8751 9.1088 10.7994 9.1846 10.7467 9.27587C10.6941 9.36713 10.6664 9.47065 10.6665 9.576V9.575Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3883_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.e25a9bdcd243227056c9ee1e36691ffe.svg";
export { ForwardRef as ReactComponent };